module.exports = __webpack_public_path__ + "static/media/S4N4-3.41f414f9.svg";